module.exports = __webpack_public_path__ + "static/media/folder.109ba709.png";